import * as React from "react";
import FooterMenu from "../FooterMenu";
import { Provider as PaperProvider } from "react-native-paper";

export default function Home(props) {
  return (
    <PaperProvider>
      <FooterMenu {...props} />
    </PaperProvider>
  );
}
